const narrativeFolderIconNames = ["folder"];

export default narrativeFolderIconNames;
